module.exports = __webpack_public_path__ + "react-forms-checkbox-b83816ced33ffee26b2c.svg";